export default {
  emailContactsTitle: 'Contatos que interagiram com email',
  changed: 'alterado',
  previousMonth: 'mês ant.',
  deployTitle: 'Contatos por período',
  daily: 'Diário',
  weekly: 'Semanal',
  monthly: 'Mensal',
  previousDay: 'ontem',
  previousWeek: 'sem. ant.',
};
